<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
      <div class="col-md-2">
        <label for="starDate">{{$t('Tarixdən')}}</label>
        <el-date-picker size="small" id="starDate"  format="dd.MM.yyyy" type="date" :clearable="false" v-model="item.startDate">
        </el-date-picker>
      </div>
      <div class="col-md-2">
        <label for="endDate">{{$t('Tarixədək')}}</label>
        <el-date-picker size="small" id="endDate"  format="dd.MM.yyyy" type="date" :clearable="false" v-model="item.endDate">
        </el-date-picker>
      </div>

      <div class="col-md-6">
        <el-label>{{$t('Axtarış_növü')}}</el-label>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-select style="width: 100%" size="small" v-model="item.searchType">
              <el-option :label="$t('--_Bütün_--')" :value="0"></el-option>
              <el-option :label="$t('Hadisə_nömrəsi')" :value="1"></el-option>
              <el-option :label="$t('DQN')" :value="2"></el-option>
            </el-select>
            &nbsp;
            <el-input size="small" :placeholder="$t('Axtar')" :disabled="item.searchType == 0" v-model="item.searchText">
              <template slot="prepend"> </template>
            </el-input>
            &nbsp;
            <el-button :title="$t('Forma_4')" size="small" type="primary" icon="el-icon-search" @click="clickSearch"></el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <el-table  ref="elTable" v-loading="loading" :data="displayData" style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="row" style="margin-left: 40px; background-color: #f5f5f5; padding: 8px 0;width: 90%;">
                <div class="col-11">
                  <span style="font-size: var(--font-primary); display: inline-block;" v-html="scope.row.participants"></span>
                </div>
              </div>
            </template>
          </el-table-column>
                    <el-table-column :label="$t('Hadisə_#')" sortable prop="dispAccidentNumber" width="120">
            <template #default="scope">
              <span style="font-weight: bold">{{ scope.row.dispAccidentNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Sığortalı')" prop="employeeFullName" width="250">
          </el-table-column>
          <el-table-column :label="$t('Sığortalı_DQN')" prop="carNumber" width="150">
          </el-table-column>
          <el-table-column :label="$t('Hadisə_məlumatları')" prop="incidentRegionName" width="150">
          </el-table-column>
          <el-table-column :label="$t('Hadisə_məlumatları')" prop="actionDateStr">
          </el-table-column>
          <el-table-column :label="$t('Status')" width="300">
            <template slot-scope="scope">
              <status-label
                :type="scope.row.completionStatusId === '2' ? 'green' : 'red'" />
              {{ scope.row.completionStatusName }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button @click="scope.row.id" style="padding: 0 !important" size="mini">
                <i :title="$t('Forma4_yüklə')" class="fa-solid fa-download"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="filter.page" :page-sizes="[10, 30, 50, 100, 200]" :page-size="filter.pagesize"
            layout="sizes, prev, pager, next" :total="this.data.length">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DateToString, AddMonths, AddDays } from "../../src/services/helper";
import { GetForm4AllAccidents } from "../../src/services/common";
import StatusLabel from "./components/StatusLabel.vue";
export default {
  components: {
      StatusLabel
    },
  data() {

    return {
      loading: false,
      data: [],
      search: "",
      item: { startDate: null, endDate: null, searchType: 0, searchText: null },
      displayData: [],
      filter: {
        page: 1,
        pagesize: 50,
      },

    };
  },
  methods: {


    clickSearch() {
      this.filter.page = 1
      this.getData();
    },
    getData() {
      this.loading = true;
      if (this.item.searchText == "") {
        this.item.searchText = null;
      }
      this.item.startDate = DateToString(this.item.startDate);
      this.item.endDate = DateToString(this.item.endDate);

      GetForm4AllAccidents(this.item).then((response) => {
        this.loading = false;
        if (response.data.data) {
          this.data = response.data.data;
          this.getDisplayData();
        }
      });
    },
    getDisplayData() {
      this.displayData = this.data.slice((this.filter.page - 1) * this.filter.pagesize, this.filter.page * this.filter.pagesize)
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.getDisplayData();
    },
    handleSizeChange(val) {
      this.filter.pagesize = val
      this.getDisplayData();
    },
    loadTime() {
      this.item.startDate = AddDays(new Date(), -6);
      this.item.endDate = AddDays(new Date(), +1);
    },
  },
  mounted() {
    this.loadTime();
    this.getData();
  },
  computed: {
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
